module.exports = __webpack_public_path__ + "static/media/bg_index_3.08421364.png";